import PropTypes from 'prop-types';
import withBreakpoints from '@/hocs/withBreakpoints';
import {H3, P} from '@/typography';
import BoxGrid from '@/ui/box-grid';
import {GridItem, GridLayout} from '@/ui/grid/grid-layout';
import stepsStyles from './steps.module.scss';

const propTypes = {
  stepsContent: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      copy: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    })
  ).isRequired,
  lineColor: PropTypes.string
};

const Steps = withBreakpoints({
  mobile: ({stepsContent, Url = '/partnership-program/apply'}) => (
    <GridLayout Col={3} autoRows>
      {stepsContent.map((item, index) => (
        <GridItem key={index}>
          <div className={stepsStyles.step}>
            <div className={stepsStyles.circle}>{index + 1}</div>
            <div
              className={`${stepsStyles['step-lines']} ${index === stepsContent.length - 1 ? stepsStyles['last-step'] : ''}`}>
              <BoxGrid backgroundColor="var(--neutral300)" Url={Url} UrlCopy="Partner with us">
                <H3>{item.title}</H3>
                <P>{item.copy}</P>
              </BoxGrid>
            </div>
          </div>
        </GridItem>
      ))}
    </GridLayout>
  ),
  desktop: ({stepsContent, lineColor = 'neutral300', Url = '/partnership-program/apply'}) => (
    <>
      <div className={stepsStyles['steps-container']}>
        {stepsContent.map((_, i) => (
          <div className={stepsStyles.step} key={i}>
            <div className={stepsStyles.circle}>{i + 1}</div>
            {i < stepsContent.length - 1 && (
              <div className={`${stepsStyles.line} ${stepsStyles[`line-${lineColor}`]}`} />
            )}
          </div>
        ))}
      </div>
      <GridLayout Col={3} autoRows>
        {stepsContent.map((item, index) => (
          <GridItem key={index}>
            <BoxGrid backgroundColor="var(--neutral300)" Url={Url} UrlCopy="Partner with us">
              <H3>{item.title}</H3>
              <P>{item.copy}</P>
            </BoxGrid>
          </GridItem>
        ))}
      </GridLayout>
    </>
  ),
  tablet: ({stepsContent, lineColor = 'neutral300', Url = '/partnership-program/apply'}) => (
    <GridLayout Col={1} autoRows>
      {stepsContent.map((item, index) => (
        <GridItem key={index}>
          <div className={stepsStyles.step}>
            <div className={stepsStyles.circle}>{index + 1}</div>
            <div
              className={`${stepsStyles['step-lines']} ${index === stepsContent.length - 1 ? stepsStyles['last-step'] : ''}`}>
              <BoxGrid backgroundColor="var(--neutral300)" Url={Url} UrlCopy="Partner with us">
                <H3>{item.title}</H3>
                <P>{item.copy}</P>
              </BoxGrid>
            </div>
          </div>
        </GridItem>
      ))}
    </GridLayout>
  )
});

Steps.propTypes = propTypes;

export default Steps;
